import React, {useRef,useEffect} from 'react'
import { taxtReveal, timeToReadyTl } from '../../utils/gsapService';
import Button from '../UI/Button'
import MultiBottle from './MultiBottle'
import { gsap, ScrollTrigger } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger); 

export default function Quality() {

    const headingLine = useRef(null);
    const desLine = useRef(null); 
    const btn = useRef(null); 
  
    useEffect(() => { 
  
      let textRevealTl = null;
      const aniStart = setTimeout(()=>{ 
        textRevealTl = taxtReveal([headingLine.current, desLine.current], headingLine.current, btn.current);
        ScrollTrigger.refresh();
      }, timeToReadyTl.firstDelay);
      ScrollTrigger.refresh();  


      return () => {
        if(textRevealTl != null){ 
          textRevealTl.tl.kill();
          textRevealTl.Lines.revert();  
        }
        clearTimeout(aniStart);
      };

      

    }, []); 

  return (
    <section className="quality-section bg-body">
        <div className="container">
            <div className="row">
                <div className="col-lg-7">
                    <div className="text-content text-content-wrap">
                        <h2 className="title-md" ref={headingLine}>Quality, without compromise.</h2>
                        <p className="des max-w500" ref={desLine}>We believe Saint Cloud Kentucky Straight Bourbon to be truly unique. Our focus is to present the highest quality experience to the true whiskey connoisseur, without compromise or limitation. Our bourbon is a culmination of years of effort, planning and execution with one goal in mind - your enjoyment.</p>
                        <Button href="#" ref={btn}>BUY NOW</Button> 
                    </div>
                </div>
            </div>
        </div>
        <MultiBottle/> 
    </section>
  )
} 
